import { useQuery } from "@tanstack/react-query";
import { getStatesByCountry } from "../Services/GetLocation";

export const useStatesByCountry = (country) => {
    return useQuery({
        queryKey: ["states", country],
        queryFn: () => getStatesByCountry(country),
        enabled: !!country, // ensures it runs only when country is truthy
        staleTime: 5 * 60 * 1000, // cache for 5 minutes
    });
};